import { useSelector } from "react-redux";

import {
  getIsOrderingAllowed,
  getIsThirdPartyOrderingProhibited,
} from "redux/selectors/complianceRules";
import { getCurrentDispensary } from "redux/selectors/dispensary";

import NonCompliantMenu from "../NonCompliantMenu";

const MenuNotAvailable: React.FC<{
  className?: string;
}> = ({ className }) => {
  const thirdPartyOrderingProhibited = useSelector(
    getIsThirdPartyOrderingProhibited,
  );
  const { featureTier, country, retailType } =
    useSelector(getCurrentDispensary);

  const isInfoTier = featureTier === "info";
  const isDispensaryRetailType = retailType === "dispensary";

  let isLeaflyOrderingAllowed = useSelector(getIsOrderingAllowed);

  // * Only "dispensary" types are restricted, since clinic and cbd-store types
  // * typically don't sell restricted items.
  if (!isDispensaryRetailType) {
    isLeaflyOrderingAllowed = true;
  }

  if (
    !thirdPartyOrderingProhibited &&
    !isLeaflyOrderingAllowed &&
    isDispensaryRetailType
  ) {
    return (
      <NonCompliantMenu
        className={className}
        hideCTA={isInfoTier}
        thirdPartyOrderingProhibited={thirdPartyOrderingProhibited}
        isLeaflyOrderingAllowed={isLeaflyOrderingAllowed}
      />
    );
  }

  return isInfoTier ? (
    <div className="pt-xl">
      <div className="container flex flex-col items-center rounded-lg bg-leafly-white py-xl px-lg">
        <p className="font-bold text-sm m-0">
          This {country === "CA" ? "store" : retailType} is currently unverified
        </p>
      </div>
    </div>
  ) : null;
};

export default MenuNotAvailable;
